import { useSelectedRoofSectionContext } from '~/components/Panels/SelectedRoofSectionPanel/hooks/useSelectedRoofSectionContext'
import { TABS } from '~/components/Panels/SelectedRoofSectionPanel/util'
import { primaryToSecondaryTypes, structureStyles } from '~/config/mountingStructures'
import { useAppSelector } from '~/store/hooks'
import { RoofSection } from '~/store/objects/types'
import { DimensionInput } from '~/ui/DimensionInput'
import { Select, SelectItem } from '~/ui/Select'
import { TabPanel } from '~/ui/Tabs'

export const SecondaryStructuresTabPanel = () => {
  const { selectedRoofSection, handleUpdate } = useSelectedRoofSectionContext()
  const { primaryStructureType, secondaryStructureType, secondaryStructureDepth, secondaryStructureStyle } =
    selectedRoofSection
  const isLocked = useAppSelector(state => state.layers.layers.ROOF_SECTIONS.locked)

  return (
    <TabPanel className="p-1 space-y-3" id={TABS.secondary}>
      <Select
        className="overflow-hidden"
        label="Type"
        isDisabled={isLocked}
        selectedKey={secondaryStructureType}
        onSelectionChange={type =>
          handleUpdate({ secondaryStructureType: type as RoofSection['secondaryStructureType'] })
        }
        items={primaryToSecondaryTypes[primaryStructureType].map(({ value }) => ({ id: value, value }))}
      >
        {mountingType => <SelectItem value={mountingType}>{mountingType.value}</SelectItem>}
      </Select>
      <DimensionInput
        showStepperButtons
        isDisabled={isLocked}
        label="Depth"
        value={secondaryStructureDepth}
        onCommit={value => handleUpdate({ secondaryStructureDepth: value })}
      />
      <Select
        className="overflow-hidden"
        label="Style"
        isDisabled={isLocked}
        selectedKey={secondaryStructureStyle}
        onSelectionChange={style =>
          handleUpdate({ secondaryStructureStyle: style as RoofSection['secondaryStructureStyle'] })
        }
        items={structureStyles.map(({ value }) => ({ id: value, value }))}
      >
        {style => <SelectItem value={style}>{style.value}</SelectItem>}
      </Select>
    </TabPanel>
  )
}
